module.exports = __webpack_public_path__ + "img/Add-Image-Placeholder.ac310708.png";